import { BlockElementType } from './BlockElementType';
import { TextObjectType } from './TextObjectType';
export var isContextBlockElement = function (block) {
    switch (block.type) {
        case BlockElementType.IMAGE:
        case TextObjectType.PLAIN_TEXT:
        case TextObjectType.MARKDOWN:
            return true;
        default:
            return false;
    }
};
//# sourceMappingURL=isContextBlockElement.js.map